module.exports = __webpack_public_path__ + "img/IMG_5028-min.4ca46418.jpg";